module.exports = __webpack_public_path__ + "img/gold-card-no-logo.f6f0e248.png";